import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Communities from '@/components/communities/Communities'
import Community from '@/components/communities/Community'
import Plans from '@/components/plans/Plans'
import IndividualPlan from '@/components/plans/IndividualPlan'
import About from '@/components/about/About'
import Testimonials from '@/components/about/Testimonials'
import WhoWeAre from '@/components/about/WhoWeAre'
import Contact from '@/components/Contact'
import Client from '@/components/Client'
import SiteMap from '@/components/SiteMap'
import VueAnalytics from "vue-analytics";

Vue.use(Router);

const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'Home',
            component: Home
        },
        {
            path: '/communities',
            name: 'Communities',
            component: Communities
        },
        {
            path: '/communities/:name',
            name: 'Community',
            component: Community
        },
        {
            path: '/plans',
            name: 'Plans',
            component: Plans
        },
        {
            path: '/plans/:name',
            name: 'IndividualPlan',
            component: IndividualPlan
        },
        {
            path: '/about',
            name: 'About',
            component: About,
            children: [
                {
                    path: '/about/testimonials',
                    name: 'Testimonials',
                    component: Testimonials
                },
                {
                    path: '/about/us',
                    name: 'WhoWeAre',
                    component: WhoWeAre
                }
            ]
        },
        {
            path: '/contact',
            name: 'Contact',
            component: Contact
        },
        {
            path: '/client',
            name: 'Client',
            component: Client
        },
        {
            path: '/sitemap',
            name: 'Site',
            component: SiteMap
        },
        {
            path: '*'
        }
    ],
    scrollBehavior () {
        return { x: 0, y: 0 }
    }
});

Vue.use(VueAnalytics, {
    id: 'UA-120359476-1',
    disableScriptLoader: true,
    router
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js